import React from 'react'
import PropTypes from 'prop-types'
import { useNavigate } from 'react-router'
import './_page-header.scss'

const backArrow = (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13 8H3M3 8L7.5 3.5M3 8L7.5 12.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
)

function PageHeader({ title, to }) {
  const navigate = useNavigate();

  const handleBack = () => {
    if (to) {
      navigate(to);
    } else {
      navigate(-1);
    }
  }

  return (
    <div className="page-header">
      <button
        type="button"
        className="page-header__back"
        onClick={handleBack}
        data-testid="page-header-back"
      >
        {backArrow}
        <span className="page-header__title">{title}</span>
      </button>
    </div>
  )
}

PageHeader.propTypes = {
  title: PropTypes.string.isRequired,
  to: PropTypes.string
}

export default PageHeader
